<script>
import http from '@/utils/http'
import { mapState } from 'vuex'
import toast from '@/utils/toast'
import LogoutDialog from '@/components/login/LogoutDialog.vue'
import bus from 'vue3-eventbus'
import MyCashLevelDialog from '@/components/dialog/MyCashLevelDialog.vue'
import EarnTipsDialog from '@/components/dialog/EarnTipsDialog.vue'
import lottie from 'lottie-web'
import invitation from '@/assets/invitaion-mycash.json'
import recharge from '@/assets/recharge-mycash.json'

export default {
  components: {
    MyCashLevelDialog,
    LogoutDialog,
    EarnTipsDialog
  },
  computed: {
    ...mapState(['pn', 'aid', 'pkg', 'uid', 'channel', 'code', 'token', 'appConfig']),
    nextLevelName () {
      if (!this.appConfig.level || !this.userData) {
        return
      }
      for (let i = 0; i < this.appConfig.level.length; i++) {
        const item = this.appConfig.level[i]
        if (item.level === this.userData.levels + 1) {
          return item.levelEnDesc
        }
      }
      return ''
    },
    currentInvatationValue () {
      if (!this.appConfig.level || !this.userData) {
        return
      }
      for (let i = 0; i < this.appConfig.level.length; i++) {
        const item = this.appConfig.level[i]
        if (item.level === this.userData.levels) {
          return item.invatationValue
        }
      }
      return ''
    },
    currentInvatationRate () {
      if (!this.appConfig.level || !this.userData) {
        return
      }
      for (let i = 0; i < this.appConfig.level.length; i++) {
        const item = this.appConfig.level[i]
        if (item.level === this.userData.levels) {
          return item.affiliateEarningsDoc
        }
      }
      return ''
    },
    totalShowCommision () {
      if (!this.userData) {
        return
      }
      return '$ ' + this.userData.totalShowCommision
    },
    showBalance () {
      if (!this.userData) {
        return
      }
      return '$ ' + this.userData.showBalance
    }
  },
  mounted () {
    const user = this.$store.state.user
    if (user) {
      this.userData = user
    }
    this.requestUserInfo()

    lottie.loadAnimation({
      container: this.$refs.invitation,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData:invitation
    })

    lottie.loadAnimation({
      container: this.$refs.recharge,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData:recharge
    })
  },
  methods: {
    logout () {
      this.$store.commit('token', '')
      this.dismissLogout()
      bus.emit('main_navi', 'Earn Money')
      localStorage.setItem('login_state', '0')
      this.savedata('ios_token', '')
      this.savedata('ios_code', '')
    },
    dismissLogout () {
      this.showLogout = false
    },
    dismissLevel () {
      this.showLevel = false
    },
    withdraw () {
      if (window.matchMedia('(orientation: portrait)').matches) {
        this.$router.push({
          path: '/web',
          query: { url: http.baseH5Url + '/withdraw?pn=' + this.pn + '&channel=' + this.channel + '&pkg=' + this.pkg + '&token=' + this.$store.state.token },
          param: { url: http.baseH5Url + '/withdraw?pn=' + this.pn + '&channel=' + this.channel + '&pkg=' + this.pkg + '&token=' + this.$store.state.token }
        })
      } else if (window.matchMedia('(orientation: landscape)').matches) {
        this.$router.push({
          path: '/withdraw-us'
        })
      }
    },
    routerMyAffiliate () {
      this.$router.push('/myAffiliate')
    },
    routerMyCommission () {
      this.$router.push('/myCommission')
    },
    routerMyReferrals () {
      this.$router.push('/myReferrals')
      // this.$router.push({
      //   path: '/landweb',
      //   query: { url: 'myReferrals.html' },
      //   param: { url: 'myReferrals.html' }
      // })
    },
    savedata (key, value) {
      if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.savedata.postMessage({
          key: key,
          value: value
        })
      }
    },
    requestUserInfo () {
      const requestBody = {
        uid: this.uid,
        aid: this.aid,
        channel: this.channel,
        pkg: this.pkg,
        pn: this.pn,
        code: this.code,
        token: this.token,
        region: 'US',
      }
      http.postHttp('/region/customizedCarousel/queryUserInfo', requestBody).then((resp) => {
        if (resp.code !== 0) {
          toast.show(resp.msg)
          return
        }
        this.userData = resp.data
        this.$refs.progress.style.width = resp.data.currentLevels / resp.data.currentNextLevelNum * 100 + '%'

        this.$store.commit('user', resp.data)

        this.anim = lottie.loadAnimation({
          container: this.$refs.lottieRef,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData:this.animPic[this.userData.levels]
        })
      })
    },
    showLevelDetail () {
      this.$router.push('/rulesDetail')
    },
    showLevelDialog () {
      bus.emit('showLevelDialog', true)
    },
  },
  data () {
    return {
      userData: {},
      levelPic: [
        require('@/assets/level_big_bronze.png'),
        require('@/assets/level_big_silver.png'), require('@/assets/level_big_gold.png'),
        require('@/assets/level_big_platinum.png'), require('@/assets/level_big_diamond.png'),
        require('@/assets/level_big_king.png')],
      levelTxtBg: [
        require('@/assets/bronze_txt_bg.png'),
        require('@/assets/silver_txt_bg.png'), require('@/assets/gold_txt_bg.png'),
        require('@/assets/platinum_txt_bg.png'), require('@/assets/diamond_txt_bg.png'),
        require('@/assets/king_txt_bg.png')],
      animPic: [
        require('@/assets/bronze.json'),
        require('@/assets/silver.json'), require('@/assets/gold.json'),
        require('@/assets/platinum.json'), require('@/assets/diamonds.json'),
        require('@/assets/diamonds.json')],
      showLogout: false,
      showLevel: false
    }
  }
}
</script>

<template>
  <div id="my_cash_page">
    <div id="level_info">
      <img src="@/assets/cash_level_bg.png">
      <div ref="lottieRef" class="level-img"  @click="showLevelDetail"></div>
      <p :style="{ 'background-image': 'url(' + levelTxtBg[userData.levels] + ')' }"></p>
      <div id="level_award">
        <div class="award_info">
          <div ref="invitation"></div>
          <div>
            <p class="rate_txt">{{ currentInvatationValue }}/</p><p class="rate_txt2">person</p>
          </div>

        </div>

        <div class="recharge_info">
          <div ref="recharge"></div>
          <div>
            <p class="rate_txt">{{ currentInvatationRate }}</p><p class="rate_txt2">cash</p>
          </div>
        </div>
      </div>
      <div id="level_info_name">
        <p>{{ userData.levelEnDesc }}</p>
        <p>{{ nextLevelName }}</p>
      </div>
      <div id="level_progress_container">
        <div id="level_progress" ref="progress"></div>
        <p>{{ userData.currentLevels }}/{{ userData.currentNextLevelNum }}</p>
      </div>
      <p>You can earn 1 experience point if your friends recharge $1.</p>

      <img class="level-rule" src="@/assets/level_rule_icon.png" @click="showLevelDialog">
    </div>
    <div >
      <div id="user_info">
        <div id="user_info_header">
          <div/>
          <div>
            <div>
              <span style>{{ userData.username }}</span> <span>( code:{{ userData.code }} )</span>
            </div>
            <div>
              <span>Yesterday’s Data: </span><span>$ {{ userData.yesterdayShowBalance }}</span>
            </div>
          </div>
          <div>
            <img src="@/assets/cash_info_exit.png" id="cash_info_exit" @click="showLogout=true">
            <span id="version_info">Version - 1.0</span>
          </div>
        </div>

        <div class="cash_info">
          <div class="line"></div>
          <div class="cash_info_account">
            <span class="cash_info_key">Total Commission: </span>
            <span class="cash_info_value">{{ totalShowCommision }}</span>
          </div>
          <div class="line"></div>
          <div class="cash_info_account">
            <span class="cash_info_key">Total Referrals: </span>
            <span class="cash_info_value">{{ userData.inviteCount }}</span>
          </div>
          <div class="line"></div>
          <div class="cash_info_account">
            <span class="cash_info_key">Total Withdrawals: </span>
            <span class="cash_info_value">{{ userData.withdrawCount }}</span>
          </div>
        </div>

      </div>

      <div id="btn_actions">
        <div>
          <p>Current Balance</p>
        </div>
        <div class="tv-balance">
          <p>{{ showBalance }}</p>
          <div class="withdraw" @click="withdraw">
        </div>
        </div>

        <div class="my-commission" @click="routerMyCommission">
        </div>
        <div class="my-affiliate" @click="routerMyAffiliate">
        </div>
        <div class="my-invite" @click="routerMyReferrals">
        </div>
      </div>
    </div>
  </div>

  <div v-if="showLogout" class="dialog_contain">
    <LogoutDialog @dismiss='dismissLogout' @logout="logout"/>
  </div>
  <div v-if="showLevel" class="dialog_contain" @click="dismissLevel">
    <MyCashLevelDialog @dismiss='dismissLevel'/>
  </div>
</template>

<style scoped>

#my_cash_page {
  width: 104.8rem;
  display: flex;
}

#level_info {
  width: 62rem;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  /*align-content: center;*/

}

#level_info > :first-child {
  position: absolute;
  top: -5%;
  width: 45.8rem;
  height: 36.4rem;
  pointer-events: none;
}

.level-rule{
  position: absolute;
  top: 5%;
  right: 5%;
  width: 5.4rem;
  height: 5.7rem;
}

@media screen and (orientation: portrait) {
  .level-img {
    z-index: 0;
    height: 30vw;
    margin-top: 15%;

  }
}

@media screen and (orientation: landscape) {
  .level-img {
    z-index: 0;
    height: 30vh;
    margin-top: 15%;

  }
}

#level_info > :nth-child(3) {
  width: 24.2rem;
  height: 5.8rem;
  line-height: 5rem;
  font-size: 2.8rem;
  text-align: center;
  margin-top: -4rem;
  background-image: url("@/assets/diamond_txt_bg.png");
  background-size: 100% 100%;
  color: white;
  font-weight: bolder;
  z-index: 0;
}

#level_award {
  width: 100%;
  height: 10.6rem;
  display: flex;
  align-content: center;
  z-index: 0;
}

.award_info {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  flex: 1;
}

.award_info > :first-child {
  /* background-image: url("@/assets/my_cash_person.png"); */
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: center;
  width: 21.8rem;
  height: 8.2rem;
}

.award_info > :nth-child(2) {
  color: white;
  width: 21.4rem;
  height: 4.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.2rem;
  background-size: cover;
  background-image: url("@/assets/bg_rate_text.png");
}

.recharge_info {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  flex: 1;
}

.recharge_info > :first-child {
  /* background-image: url("@/assets/my_cash_gift.png"); */
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: center;
  width: 21.8rem;
  height: 8.2rem;
}

.recharge_info > :nth-child(2) {
  color: white;
  width: 21.4rem;
  height: 4.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.2rem;
  background-size: cover;
  background-image: url("@/assets/bg_rate_text.png");
}

.rate_txt {
  font-size: 3.6rem;
  background: linear-gradient(
    to bottom,
    #FFFAC4,
    #E3BF56
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  /* -webkit-text-stroke: 0.1rem #A62A01; */
  font-weight: 900;
}

.rate_txt2 {
  font-size: 2.4rem;
  background: linear-gradient(
    to bottom,
    #FFFAC4,
    #E3BF56
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  /* -webkit-text-stroke: 0.1rem #A62A01; */
  font-weight: 700;
}

#level_info_name {
  display: flex;
  justify-content: space-between;
  width: 90%;
  /*align-content: space-between;*/
}

#level_info_name > :first-child {
  color: #ffffff;
  font-size: 2.4rem;
  -webkit-background-clip: text;
  /* -webkit-text-stroke: 0.1rem #6C0E81; */
  font-weight: 700;
}

#level_info_name > :last-child {
  color: #ffffff;
  font-size: 2.4rem;
  -webkit-background-clip: text;
  /* -webkit-text-stroke: 0.1rem #6C0E81; */
  font-weight: 700;
}

#level_info :nth-child(6) {
  width: 90%;
}

#level_progress_container {
  background: rgba(177, 93, 29, 1);
  width: 100%;
  height: 2.6rem;
  padding: 0 0.1rem;
  border-radius: 1.3rem;
  display: flex;
  justify-content: center;
  align-content: center;
  position: relative;
}

#level_progress {
  background: linear-gradient(#0B6F03, #4BDB40, #D5FED7);
  width: 50%;
  height: inherit;
  border-radius: 1.3rem;
  position: absolute;
  left: 0;
}

#level_progress_container > p {
  z-index: 1;
  color: #FFF;
  font-size: 1.8rem;
  align-self: center;
}

#level_info :nth-child(7) {
  color: #F4E9FF;
  font-size: 1.4rem;
}

* {
  box-sizing: border-box;
}

#user_info {
  border-radius: 0.6rem;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  background-size: cover;
  width: 56.9rem;
  height: 30.5rem;
  margin-top: 1rem;
  background-image: url("@/assets/bg_mycash_content.png");
}

#user_info_header {
  height: 6.8rem;
  display: flex;
  margin-bottom: 1rem;
  /*align-content: center;*/

}

#user_info_header > :first-child {
  background-image: url("@/assets/header_default.png");
  background-size: cover;
  box-sizing: border-box;
  align-self: center;
  border-radius: 100%;
  aspect-ratio: 1 / 1;
  height: 8rem;
  width: 8rem;
}

#user_info_header > :nth-child(2) {
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-self: center;
  flex-direction: column;
  margin-left: 1.4rem;
  flex: 1;
}

#user_info_header > :nth-child(2) > :first-child > :first-child {
  color: white;
  font-size: 2.8rem;
  font-weight: bolder;
}

#user_info_header > :nth-child(2) > :first-child > :nth-child(2) {
  color: white;
  font-size: 2.2rem;
  margin-left: 1rem
}

#user_info_header > :nth-child(2) > :nth-child(2) > :first-child {
  color: rgba(255, 255, 255, 0.5);
  font-size: 2.2rem
}

#user_info_header > :nth-child(2) > :nth-child(2) > :nth-child(2) {
  color: #FBEB6E;
  font-size: 2.2rem;
  margin-left: 1rem
}

#user_info_header > :nth-child(3) {

  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

}

#cash_info_exit {
  width: 2.8rem;
  height: 2.8rem;
  align-self: end;
}

#version_info {
  color: rgba(255, 255, 255, 0.5);
  margin-top: 0.2rem;
  font-size: 2.2rem;
}

#user_info > :nth-child(2) {
  height: 25%;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.cash_info_account {
  display: flex;
  width: 100%;
  margin-top: 1.5rem;
  box-sizing: border-box;
  justify-content: space-between;
}

.cash_info_key {
  color: #86B6F5;
  font-weight: 700;
  font-size: 2.4rem;

}

.cash_info_value {
  color: white;
  font-weight: 600;
  font-size: 2.4rem;
  text-shadow: 0.2rem 0.2rem 0 #000, 1px 0.2rem 0 #000, 0.2rem 1px 0 #000, 1px 1px 0 #000;
}

.line {
  width: 100%;
  height: 0.1rem;
  background: #7377E5;
  flex-shrink: 0;
  margin-top: 1.5rem;
}

.cash_info {
  display: flex;
  flex-direction: column;
}

#btn_actions {
  background-size: cover;
  background-image: url("@/assets/bg_mycash_content2.png");
  flex: 1;
  margin-top: 1rem;
  display: flex;
  flex-flow: wrap;
  align-content: start;
  padding-top: 2rem;
  padding-bottom: 2rem;
  padding-left: 1.2rem;
  padding-right: 1rem;
  width: 56.9rem;
  height: 28.8rem;
}

#btn_actions > :first-child {
  width: 100%;
  padding-bottom: 1rem;
  display: flex;
  align-content: center;
  justify-content: center;

}

#btn_actions > :first-child > p {
  width: 100%;
  justify-content: center;

  font-size: 2.6rem;
  color: white;
}

.tv-balance {
  width: 100%;
  background: rgba(30, 14, 14, 0.5);
  border-radius: 0.4rem 0 0 0.4rem;
  box-sizing: border-box;
  height: 6.1rem;
  display: flex;
  flex-direction: row;
  padding-left: 2rem;
}

#btn_actions > :nth-child(2) > p {
  width: 65%;
  color: #FDD41D;
  font-weight: bolder;
  font-size: 4.2rem;
  align-self: center;
}

.withdraw {
  width: 35%;
  background-image: url("@/assets/iv_user_withdraw.png");
  background-size: contain;
  background-repeat: no-repeat;
  height: 6.1rem;
  display: flex;
  align-self: flex-end;
  align-content: center;
  justify-content: center;
  border-radius: 0 0.25rem 0.25rem 0;
}

.withdraw:active {
  opacity: 0.6;
}

.withdraw > p {
  color: white;
  align-self: center;
  font-weight: bolder;
  font-size: 2.8rem;
}

.my-commission {
  background-image: url("@/assets/iv_my_commission.png");
  background-size: 100% 100%;
  margin-top: 1.7rem;
  width: 17.4rem;
  height: 13rem;
  display: flex;
  align-content: center;
  justify-content: center;
}

.my-commission:active {
  opacity: 0.6;
}

.my-commission > p {
  color: white;
  align-self: center;
  font-size: 2.8rem;
  text-shadow: 0.2rem 0.2rem 0 #003289, 1px 0.2rem 0 #003289, 0.2rem 1px 0 #003289, 1px 1px 0 #003289;
}

.my-affiliate {
  background-image: url("@/assets/iv_my_affiliates.png");
  background-size: 100% 100%;
  margin-top: 1.7rem;
  width: 17.4rem;
  height: 13rem;
  margin-left: 1rem;
  display: flex;
  align-content: center;
  justify-content: center;
}

.my-affiliate:active {
  opacity: 0.6;
}

.my-affiliate > p {
  color: white;
  align-self: center;
  font-size: 2.8rem;
  text-shadow: 0.2rem 0.2rem 0 #7252F7, 1px 0.2rem 0 #7252F7, 0.2rem 1px 0 #7252F7, 1px 1px 0 #7252F7;
}

.my-invite {
  background-image: url("@/assets/iv_my_referrals.png");
  background-size: 100% 100%;
  margin-top: 1.7rem;
  width: 17.4rem;
  height: 13rem;
  display: flex;
  margin-left: 1rem;
  align-content: center;
  justify-content: center;
}

.my-invite:active {
  opacity: 0.6;
}

.my-invite > p {
  color: white;
  align-self: center;
  font-size: 2.8rem;
  text-shadow: 0.2rem 0.2rem 0 #C73506, 1px 0.2rem 0 #C73506, 0.2rem 1px 0 #C73506, 1px 1px 0 #C73506;
}
</style>
